/**
 * Action for Fetch Services
 */
export enum getServices {
  FETCH_SERVICES_REQUEST = 'FETCH_SERVICES_REQUEST'
}
